import { render, staticRenderFns } from "./ReviewStep.vue?vue&type=template&id=55e273cf&scoped=true"
import script from "./ReviewStep.vue?vue&type=script&lang=js"
export * from "./ReviewStep.vue?vue&type=script&lang=js"
import style0 from "./ReviewStep.vue?vue&type=style&index=0&id=55e273cf&prod&scoped=true&lang=css"
import style1 from "./ReviewStep.vue?vue&type=style&index=1&id=55e273cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e273cf",
  null
  
)

export default component.exports